import React, {memo, useMemo} from "react";
// local
import {ButtonTransparent} from "components/buttons/ButtonTransparent";
import {Info} from "components/Info";
import {IconPrint} from "components/icons";
import {printPage} from "helpers/helper";

const ButtonPrint = memo(
  ({
    name = "PRINT_OR_SAVE_AS_PDF",
    infoTooltip,
    tooltipPlacement,
    printTitle,
    position = "absolute",
    top,
    bottom,
    right,
    left,
    addClass,
  }) => {
    const isRightTooltip = useMemo(
      () => tooltipPlacement === "right",
      [tooltipPlacement]
    );

    const customStyles = {
      position,
      ...(top && {top}),
      ...(bottom && {bottom}),
      ...(right && {right}),
      ...(left && {left}),
      ...(isRightTooltip && {flexDirection: "row-reverse"}),
    };

    return (
      <div
        className={`print-button df-row-center ${addClass || ""}`}
        style={customStyles}
      >
        <Info addClass={`df ${isRightTooltip ? "ml-1" : "mr-1"}`} tooltip={infoTooltip} />
        <ButtonTransparent
          name={name}
          small
          icon={<IconPrint />}
          onClick={() => printPage(printTitle)}
          addClass="__button"
        />
      </div>
    );
  }
);

export default ButtonPrint;
